var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 173,
    viewBox: "0 0 411 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-64.379 60.4852C-31.687 47.8122 1.00497 47.8122 33.697 60.4852C66.389 73.1582 99.081 73.1582 131.773 60.4852C164.465 47.8122 197.157 47.8122 229.849 60.4852C262.541 73.1582 295.233 73.1582 327.925 60.4852C360.617 47.8122 393.309 47.8122 426.001 60.4852C458.693 73.1582 491.385 73.1582 524.077 60.4852",
    stroke: "#AA9180",
    strokeWidth: 1.44092
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-64.379 86.4071C-31.687 73.7341 1.00497 73.7341 33.697 86.4071C66.389 99.0801 99.081 99.0801 131.773 86.4071C164.465 73.7341 197.157 73.7341 229.849 86.4071C262.541 99.0801 295.233 99.0801 327.925 86.4071C360.617 73.7341 393.309 73.7341 426.001 86.4071C458.693 99.0801 491.385 99.0801 524.077 86.4071",
    stroke: "#AA9180",
    strokeWidth: 1.44092
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-64.379 112.329C-31.687 99.656 1.00497 99.656 33.697 112.329C66.389 125.002 99.081 125.002 131.773 112.329C164.465 99.656 197.157 99.656 229.849 112.329C262.541 125.002 295.233 125.002 327.925 112.329C360.617 99.656 393.309 99.656 426.001 112.329C458.693 125.002 491.385 125.002 524.077 112.329",
    stroke: "#AA9180",
    strokeWidth: 1.44092
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-64.379 138.251C-31.687 125.578 1.00497 125.578 33.697 138.251C66.389 150.924 99.081 150.924 131.773 138.251C164.465 125.578 197.157 125.578 229.849 138.251C262.541 150.924 295.233 150.924 327.925 138.251C360.617 125.578 393.309 125.578 426.001 138.251C458.693 150.924 491.385 150.924 524.077 138.251",
    stroke: "#AA9180",
    strokeWidth: 1.44092
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-64.379 164.173C-31.687 151.5 1.00497 151.5 33.697 164.173C66.389 176.846 99.081 176.846 131.773 164.173C164.465 151.5 197.157 151.5 229.849 164.173C262.541 176.846 295.233 176.846 327.925 164.173C360.617 151.5 393.309 151.5 426.001 164.173C458.693 176.846 491.385 176.846 524.077 164.173",
    stroke: "#AA9180",
    strokeWidth: 1.44092
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavy);
export default __webpack_public_path__ + "static/media/wavy.c72c78db1635aeb4cf626b27aee4e565.svg";
export { ForwardRef as ReactComponent };